// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"f2fd69bc","504":"7064e9cb","745":"ab676fe8","975":"242441ea"}[chunkId] + ".chunk.js";
};